import Editor from 'app/src/editor/Editor';
import * as React from 'react';

export default function EditorPage(): React.ReactElement {
	return <Editor />;
}
